<template>
    <div class="container page" style="max-width: 900px;">
<!--        <h1 class="page-title">My account</h1>-->
        <div class="page-subtitle">Hi {{ user.name }}</div>
        <p class="page-description">Welcome to your account</p>
        <div :class="{'loading-big': loading.data}"></div>
<!--        <template v-if="selected_property">-->
            <div class="service-grid">
                <router-link :to="{name: 'reports'}" class="service-grid__item">
                    <div class="service-grid__item-icon"><i class="flaticon-pie-chart"></i></div>
                    <div class="service-grid__item-title">Dynamic Reports</div>
                </router-link>
            </div>
<!--        </template>-->
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'Dashboard',
    data () {
        return {
            loading: {
                data: false
            },
        }
    },
    computed: {
        ...mapState({
            user: (state) => state.user,
            selected_property: (state) => state.selected_property,
        }),
    },
    mounted () {
        if (!this.selected_property) {
            this.$router.push({name: 'property-select'})
        }
    }
}
</script>
